// extracted by mini-css-extract-plugin
export var arrow = "slides-section-module--arrow--136bc";
export var arrowLeft = "slides-section-module--arrowLeft--fb727";
export var arrowRight = "slides-section-module--arrowRight--72cd4";
export var arrows = "slides-section-module--arrows--d8d4f";
export var arrowsWrapper = "slides-section-module--arrowsWrapper--7633f";
export var bgSlide = "slides-section-module--bgSlide--22443";
export var bgSlide1 = "slides-section-module--bgSlide1--cf506";
export var bgSlide2 = "slides-section-module--bgSlide2--481af";
export var bgSlide3 = "slides-section-module--bgSlide3--ca8af";
export var card = "slides-section-module--card--30e78";
export var cardBody = "slides-section-module--cardBody--a9de6";
export var cardHeader = "slides-section-module--cardHeader--c1349";
export var contentDesktop = "slides-section-module--contentDesktop--e3859";
export var contentMobile = "slides-section-module--contentMobile--65c95";
export var loaded = "slides-section-module--loaded--1a986";
export var section = "slides-section-module--section--e9e17";
export var sliderWrapper = "slides-section-module--sliderWrapper--00a16";
export var text = "slides-section-module--text--44253";
export var title = "slides-section-module--title--007a2";